
<ng-container [formGroup]="dateFormGroup">
  <mat-form-field appearance='outline' class='filter-date-input field-filter field'>
    <mat-label>{{data.place_holder}}</mat-label>
    <input formControlName='{{data.options.key}}' name='{{data.options.key}}' matInput [matDatepicker]='picker'>
    <mat-datepicker-toggle matSuffix [for]='picker'></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</ng-container>
